import styles from './About.module.css'
import { motion } from 'framer-motion';

import { useInView } from 'react-intersection-observer';

const phrases = [
  "I'm a freelance design and began",
  // "my career in web and full-stack development in 2020.",
  // "I later transitioned into the design field",
  // "driven by a passion for web design, web application,",
  // "branding and mobile application projects."
]




export default function AboutText() {

  return (
    <div className={styles.container}>
      <MaskText/>
     
    </div>
  )
}

export function MaskText() {
  const animation = {
    initial: {y: "100%"},
    enter: i => ({y: "0", transition: {duration: 0.75, ease: [0.33, 1, 0.68, 1],  delay: 0.075 * i}})
  }

  const { ref, inView, entry } = useInView({
    threshold: 0.75,
    triggerOnce: true
  });

  return(
    <div ref={ref} className={styles.body} data-aos="fade-up">
      {
        phrases.map( (phrase, index) => {
          return <div key={index} className={styles.lineMask}>

          

<motion.p
  custom={index}
  variants={animation}
  initial="initial"
  animate={inView ? "enter" : ""}
  className="text-bse sm:text-md  lg:text-4xl leading-normal text-start hidden  sm:leading-relaxed md:leading-loose" 
>
  I'm a freelance design and <span className="text-[#000]">began my career in web and full-stack <span className='border-[2px] border-white p-1 hover:bg-white bg- hover:text-black  rounded-3xl'>✹creative skills</span> development in 2020.</span> 
  I later transitioned into the design field, driven by a passion for web design, web application,
   <span className='!text-center lg:ml-[4vh]'> branding, and mobile application projects</span>.
</motion.p>

          </div>
        })
      }
    </div>
  )
}
